import { apiFetch } from "@/utils";
import { apiPost } from ".";
import { ComputeCustomFields } from "./trelloContentHelper";
import store from "@/store/store";

function getCards() {
  return new Promise((resolve, reject) => {
    apiFetch("trello/cards").then(res => {
      let newRes = res.map(card => ComputeCustomFields(card))
      resolve(newRes);
    })
      .catch(reject);
  })
}

function getBoards() {
  return apiFetch("trello/boards");
}

function getLists(boardId) {
  return apiFetch("trello/lists?boardId=" + boardId);
}

function getCardsByList(listId) {
  return apiFetch("trello/cardsByList?listId=" + listId);
}

function getCardInfos(cardId) {
  return new Promise((resolve, reject) => {
    return apiFetch("trello/cardInfo?cardId=" + cardId).then(res => {
      let newRes = ComputeCustomFields(res);
      resolve(newRes);
    })
      .catch(reject);
  })
}

function createCard(name, desc, due, idList, idLabels, idMembers) {
  return apiPost("trello/cards?name=" + name + "&desc=" + desc + "&due=" + due + "&idList=" + idList + "&idLabels=" + idLabels + "&idMembers=" + idMembers)
}

function addAttachment(cardId, file, mimeType) {
  return apiPost("trello/attachment/add?cardId=" + cardId + "&mimeType=" + mimeType, {
    file,
    name: "upload",
    mimeType
  });
}

function updateCard(card, name, desc, due, idList, idLabels, idMembers) {
  let destSdcGuidList = []
  let creatorSdcGuid = ""
  if (card.custom) {
    destSdcGuidList = card.membersSdc
    for (let idTrello of JSON.parse(idMembers)) { // On ajoute les nouveaux membres
      let user = store.state.trelloConfig.userConfig.find(u => u.idTrello == idTrello)
      if (user && destSdcGuidList.indexOf(user.id) == -1) {
          destSdcGuidList.push(user.id);
      }
    }
    destSdcGuidList = destSdcGuidList.filter(sdcGuid => sdcGuid != store.state.self.userSdcGuid);
    creatorSdcGuid = card.initialDesc.demandeur.sdcGuid;
  }
  return apiPost("trello/cards/update?cardId=" + card.id + "&name=" + name + "&desc=" + desc + "&due=" + due + "&idList=" + idList + "&idLabels=" + idLabels + "&idMembers=" + idMembers + "&sdcGuidList=" + JSON.stringify(destSdcGuidList) + "&sdcGuidCreator=" + creatorSdcGuid)
}

function getLabels(idBoard) {
  return apiFetch("trello/labels?boardId=" + idBoard);
}

function createComment(card, comment) {
  let destSdcGuidList = [];
  if (card.custom) {
    destSdcGuidList = card.membersSdc.filter(sdcGuid => sdcGuid != store.state.self.userSdcGuid)
  }
  return apiPost("trello/card/comment?cardId=" + card.id + "&comment=" + comment + "&destSdcGuidList=" + JSON.stringify(destSdcGuidList));
}

function getAttachment(urlList) {
  return apiFetch("trello/attachment?url=" + urlList);
}


export default {
  getCards,
  getCards,
  getBoards,
  getLists,
  getCardsByList,
  getCardInfos,
  createCard,
  updateCard,
  getLabels,
  createComment,
  getAttachment,
  addAttachment,
}
export {
  getCards,
  getBoards,
  getLists,
  getCardsByList,
  getCardInfos,
  createCard,
  updateCard,
  getLabels,
  createComment,
  getAttachment,
  addAttachment,
}



// WEBPACK FOOTER //
// ./src/utils/trello.js